export interface Baseline {
  baseline: string;
}
export const initialBaselineState: Baseline = {
  baseline: 'median',
};
